import { generateSetChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import CheckoutTimeUtil from '@/helpers/CheckoutTimeUtil'
import { dayjs, dayjsLocal, timeZone } from "@/helpers/dayjs"
import { config } from '@/config'

//helper instance
let timeUtil = new CheckoutTimeUtil()

export default {
	namespaced: true,
	state: {
		queryLocations: [],
		deliveryMethod: "", // takeaway, delivery
		locations: [],
		//location: null,
		orderDate: null,
		orderTime: null,
		deliveryTime: null, // timespan in minutes to deliver
		orderNow: true,
		orderZip: null,
		orderNowAvailable: false,
		loading: true,
		storeLocations: [],
	},
	actions: {
    async getStoreLocations({commit}, { brand = config.BRAND, zip = null, accumulatorGroup = null } = {}) {
			commit('setLoading', { item: true });
			let result
			try {
				// TODO: this depends on the implementation if we have to reduce the resuld
				if (zip) {
					result = await service.locationsByZip({ zip, brand, accumulatorGroup })
				}
				else {
					result = await service.locations({ brand, accumulatorGroup })
				}

				commit('setStoreLocations', { item: result.locations })
			} catch(err) {
				result = null
			}
			commit('setLoading', { item: false });
			return result
		},
		async query({state, commit}, {zip, deliveryMethod}) {
			try {
				let result = await service.locationQuery({zip, brand: config.BRAND, deliveryMethod})
				commit('setQueryLocations', {item: result.zipLocations})
				return {
					list: result.zipLocations,
					zip: result.zip
				}
			} catch(err) {
				//fix an 404
				if (err.response.data && err.response.data.code == 404) {
					commit('setQueryLocations', {item: []})
					return {
						zip,
						list: []
					}
				}
				config.DEBUG && console.error(err)
				throw err
			}

		},
		async getLocations({state, commit}, { accumulatorGroup = null } = {}) {
			commit('setLoading', { item: true });
			let result
			try {
				// TODO: this depends on the implementation if we have to reduce the resuld
				result = await service.channels({ brand: config.BRAND, deliveryMethod: "", accumulatorGroup })

				// TODO: prepare this object for fast query

				commit('setLocations', { item: result })
			} catch(err) {
				result = null
			}
			commit('setLoading', { item: false });
			return result
		},
		setLocation({ state, commit, getters }, { location, deliveryMethod, deliverTime = null, zip = null, canOrderNow = null, deliveryTime = config.DELIVERY_TIME } = {}) {
			commit('setDeliveryMethod', { item: deliveryMethod })
			commit('setLocation', { item: location })
			if (zip) {
				commit('setOrderZip', { item: zip })
			}
			if (deliveryTime) {
				commit('setDeliveryTime', { item: deliveryTime })
			}
			if (canOrderNow == null) {
				if (deliveryMethod == 'delivery') {
					if (zip != null) {
						canOrderNow = !!zip.orderNowAvailable
					}
				}

				if (deliveryMethod == 'takeaway') {
					canOrderNow = !!location.location.takeaway.orderNowAvailable
				}
			}

			commit('setOrderNowAvailable', { item: canOrderNow })
			commit('setOrderNow', { item: canOrderNow })

			timeUtil.clearCache()

			let orderDate = getters.locationOrderMinDate.format('L')
			if (deliverTime) {
				orderDate = deliverTime.format('L')
			}
			commit('setOrderDate', { item: orderDate })

			let orderTime = getters.locationOrderTimes[0]
			const openingTimes = getters.locationOpeningTimes
			if (deliverTime && timeUtil.isOpenAt(deliverTime, openingTimes)) {
				orderTime = deliverTime.format('LT')
			}
			commit('setOrderTime', { item: orderTime })
		},
		clearLocation({ state, commit}) {
			if (state.location) {
				commit('setDeliveryMethod', { item: null })
				commit('setLocation', { item: null })
				commit('setOrderTime', { item: null })
				commit('setOrderDate', { item: null })
				commit('setOrderNow', { item: false })
				commit('setOrderZip', { item: null })
				commit('setOrderNowAvailable', { item: false })
				commit('setDeliveryTime', { item: null })
			}
		},
		setOrderDate({ state, commit }, { date, dateStr }) {
			commit('setOrderDate', { item: date || dateStr })
		},
		setOrderTime({ state, commit }, { timeStr }) {
			commit('setOrderTime', { item: timeStr })
		},
		setOrderNow({ state, commit }, { value }) {
			commit('setOrderNow', { item: value });
		},
	},
	getters: {
    storeLocations(state, getters, rootState, rootGetters) {
			let locations = state.storeLocations
				.sort((a, b) => a.name.localeCompare(b.name) || a.brand.localeCompare(b.brand))
				.map(location => {
					let menuUrl

					if (location.menuChannel && location.brand) {

						const brandUrl = config[`BRAND_URL_${location.brand.toUpperCase()}`];

						if (brandUrl) {
							menuUrl = `${format(brandUrl, { language: rootGetters.currentLanguage })}/menu/${location.menuChannel}`
						}
					}

					return {
						...location,
						image: location.images?.find(image => image.code == 'location_assortment_image')?.path || null,
						pdfFiles: location.pdfFiles?.map(file => {
							let path = file.path

							if (path && path.indexOf('http') !== 0) {
								path += config.SHOPMANAGER_ENDPOINT
							}

							return {
								...file,
								path
							}
						}),
						menuUrl
					}
				});
			locations = [
				...locations.filter(location => location.brand == config.BRAND),
				...locations.filter(location => location.brand != config.BRAND),
			]
			// console.log(locations)
			return locations;
		},
		queryLocations(state) {
			return state.queryLocations
		},
		locations(state) {
			let locations = state.locations
				.sort((a, b) => a.name.localeCompare(b.name) || a.location.brand.localeCompare(b.location.brand))
				.map(location => {
					return {
						...location,
						image: location.location.images?.find(image => image.code == 'location_assortment_image')?.path || null
					}
				});
			locations = [
				...locations.filter(location => location.location.brand == config.BRAND),
				...locations.filter(location => location.location.brand != config.BRAND),
			]
			return locations;
		},
		location(state) {
			return state.location
		},
		locationRegions(state, getters) {
			const locationsWithRegion = getters.locations.filter(location => location.location.region)
			const locationsWithoutRegion = getters.locations.filter(location => !location.location.region)

			let regions = [];

			if (locationsWithRegion.length) {
				regions = Object
					.entries(locationsWithRegion
						.reduce((regions, location) => {
							const region = location.location.region;
							if (!Array.isArray(regions[region])) {
								regions[region] = [];
							}
							regions[region].push(location);
							return regions;
						}, {}))
					.map(([code, locations]) => {
						return {
							code,
							locations
						}
					})
					.sort((a, b) => a.code.localeCompare(b.code));
			}

			const regionsJustified = regions.reduce((j, r) => {
				return r.locations.length > 1 || j;
			}, false);

			if (regionsJustified && locationsWithRegion.length && locationsWithoutRegion.length) {
				regions.push({
					code: 'none',
					locations: locationsWithoutRegion
				})
			}

			return regionsJustified
				? regions
				: [];
		},
		locationOrderZip(state) {
			return state.orderZip
		},
		locationClosedToday(state) {
			const shipmentId = state.deliveryMethod
			return state.location?.location[shipmentId]?.todayClosed || false
		},
		locationClosedTodayCoupon(state) {
			return state.location?.location?.todayClosedCouponCode || null
		},
		locationOpeningTimes(state, getters, rootState) {
			if (!state.location) {
				return []
			}
			const shipmentId = state.deliveryMethod
			return state.location.location[shipmentId].openingHours
		},
		locationOrderNow(state) {
			return state.orderNow;
		},
		locationOrderNowAvailable(state) {
			return state.orderNowAvailable
		},
		locationOrderMinDate(state, getters) {
			// HACK: this is not the real min date, because the current day can be closed, but it needs it currently to display
			return getters.locationTimeNow
			// const openingTimes = getters.locationOpeningTimes
			// return timeUtil.getMinDate(openingTimes)
		},
		locationOrderMaxDate(state, getters) {
			const openingTimes = getters.locationOpeningTimes
			return timeUtil.getMaxDate(openingTimes)
		},
		locationTimeNow() {
			return dayjs(config.LOCAL_TIME).tz(timeZone)
		},
		locationOrderDate(state) {
			return state.orderDate
		},
		locationOrderTime(state) {
			return state.orderTime
		},
		locationOrderDateTime(state) {
			if (state.orderDate) {
				let datetime = dayjsLocal(state.orderDate+" 12:00")
				if (state.orderTime) {
					let spl = state.orderTime.split(":")
					datetime = datetime.hour(spl[0]).minute(spl[1]).second(0)
				}
				return datetime
			}
			return null
		},

		locationOrderDisabledDates(state, getters, rootState) {
			const openingTimes = getters.locationOpeningTimes
			const minDate = getters.locationOrderMinDate
			return timeUtil.getDisabledDates(openingTimes, minDate)
		},

		locationOrderTimes(state, getters, rootState, rootGetters) {
			//TODO: check orderDate
			if (state.orderDate) {
				const openingTimes = getters.locationOpeningTimes
				return timeUtil.getOrderTimes(
					openingTimes,
					getters.locationOrderDateTime,
					getters.locationTimeNow.add(state.deliveryTime || config.DELIVERY_TIME, 'minute'), // TODO: we do not know what the current delivery time is, but it could be provided with the locations zip
					timeZone
				)
			}
			return []
		},
		locationYieldingMessages(state) {
			return state.location.location && state.location.location.yieldingMessages
				? state.location.location.yieldingMessages
				: []
		},
		locationsLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		setQueryLocations: generateSetChild('queryLocations'),
		setLocations: generateSetChild('locations'),
		setStoreLocations: generateSetChild('storeLocations'),
		setLocation: generateSetChild('location'),
		setDeliveryMethod: generateSetChild('deliveryMethod'),
		setDeliveryTime: generateSetChild('deliveryTime'),
		setOrderDate: generateSetChild('orderDate'),
		setOrderTime: generateSetChild('orderTime'),
		setOrderNow: generateSetChild('orderNow'),
		setOrderZip: generateSetChild('orderZip'),
		setOrderNowAvailable: generateSetChild('orderNowAvailable'),
		setLoading: generateSetChild('loading')
	}
}
